module.exports = "<div class=\"row\">\n  <div class=\"col\">\n    <app-npspromotion-list></app-npspromotion-list>\n  </div>\n</div>\n"